import { TranslateService } from '@ngx-translate/core';
import get from 'lodash/get';
import {
  CfbEnvironmentFeatureFlags,
  CfbFeatureFlagBundle,
  CfbFeatureFlagKey,
} from './cfb-feature-flag.model';

export const CFB_FEATURE_FLAG_TRANSLATION_KEY = 'featureFlag';

export function getCfbFeatureFlagsForEnvironment(
  translate: Pick<TranslateService, 'instant'>,
  environmentName: string,
): CfbEnvironmentFeatureFlags {
  const featureFlagBase = translate.instant(
    CFB_FEATURE_FLAG_TRANSLATION_KEY,
  ) as CfbFeatureFlagBundle;

  return get(featureFlagBase, environmentName, {});
}

export function isCfbFeatureFlagEnabled(
  translate: Pick<TranslateService, 'instant'>,
  environmentName: string,
  flagKey: CfbFeatureFlagKey,
): boolean {
  const flags = getCfbFeatureFlagsForEnvironment(translate, environmentName);

  return get(flags, flagKey) === true;
}
